<div class="welcome-modal-wrapper">
  <h2>Welcome to Autoleap!</h2>
  <p>We have loaded your Trial with sample data so you can see how a live AutoLeap account looks and feels like.</p>
  <a href="javascript:;" class="btn btn-primary float-right mt-2" (click)="close(false)">👍 Let's Start</a>
</div>
